import { XesAxios } from '@xes/terra-utils'

const baseUrl = 'https://booster.xueersi.com/'
export default {
  // 检测登录态 - 首页
  checkLogin() {
    return XesAxios.get(`${baseUrl}teacher/checkUserLoginStatus?t=${new Date().getTime()}`)
  },
  // 获取配置
  getList(params) {
    return XesAxios.get(`${baseUrl}h5EditStation/SummerVacation/GetConfig`, { params })
  },
  // 抽奖
  getReward(params) {
    return XesAxios.post(`${baseUrl}h5EditStation/SummerVacation/GetReward`, params)
  },
  // 获取当前用户基本信息  currentNum剩余次数，phoneNum 手机号
  getUserInfo(params) {
    return XesAxios.get(
      `${baseUrl}h5EditStation/SummerVacation/GetCurrentUserInfo?t=${new Date().getTime()}`,
      { params }
    )
  },
  // 新用户绑定关系
  getRelated(params) {
    return XesAxios.post(`${baseUrl}v1/h5EditStation/summer/relate/create`, params)
  },
  // 查看抽奖记录
  getExchangeList(params) {
    return XesAxios.post(`${baseUrl}h5EditStation/OperationDraw/GetLoopInfo`, params)
  },
  // addmark
  addMark(params) {
    return XesAxios.post(`${baseUrl}h5EditStation/OperationDraw/AddMark`, params)
  },
  // getmark
  getMark(params) {
    return XesAxios.post(`${baseUrl}h5EditStation/OperationDraw/GetMark`, params)
  },
  // 弹窗接口
  getUploadStatus(params) {
    return XesAxios.get(`${baseUrl}v1/h5EditStation/summer/share/get`, { params })
  },
  // 征文信息用户报名状态
  getZWInfo() {
    return XesAxios.get('https://api.xueersi.com/scorpioapi/summercampaign/activity/info')
  },
  // 课程人数
  getCourseNum(params) {
    return XesAxios.get(`${baseUrl}h5EditStation/SummerVacation/GetCourseNum`, { params })
  },
  // 获取小程序二维码
  getWxAppCode(params) {
    return XesAxios.get('https://booster.xueersi.com/poster/wechat/getWxAppCode', params)
  },
  // 分享关系绑定
  appCodeBind(params) {
    return XesAxios.get('https://booster.xueersi.com/poster/wechat/appCodeBind', params)
  },
  // 动态获取参数
  getDynamicParam(params) {
    return XesAxios.get(
      'https://booster.xueersi.com/v1/h5EditStation/summer/poster/getDynamicParam',
      { params }
    )
  },
  // 用户领课状态强制查询
  getCourseInfo(params) {
    return XesAxios.get(
      `https://booster.xueersi.com/h5EditStation/SummerVacation/InitUserGetCourseInfo?t=${new Date().getTime()}`,
      { params }
    )
  },
  getShenhe(params) {
    return XesAxios.get('https://booster.xueersi.com/v1/h5EditStation/summer/audit/status', {
      params
    })
  },
  // 下线时间
  getOffline() {
    return XesAxios.get('https://booster.xueersi.com/v1/h5EditStation/summer/offline/time')
  }
}
